import * as r from 'ramda';
import * as fn from '../../fn';

function stateToConfigImages(state) {
    const sortedProductConfigIds = r.pipe(
        r.pathOr([], ['productConfigurator', 'sortedCategoryIds']),
        fn.mapCat((categoryId) =>
            r.path(
                [
                    'productConfigurator',
                    'categories',
                    categoryId,
                    'productConfigIds',
                ],
                state
            )
        )
    )(state);
    const productConfigPositionById = r.zipObj(
        r.values(sortedProductConfigIds),
        r.map(Number, r.keys(sortedProductConfigIds))
    );

    const productConfigs = r.values(
        r.path(['productConfigurator', 'productConfigs'], state)
    );

    const isSauceSelected = r.any(
        r.allPass([r.prop('isSauce'), r.propSatisfies(r.lt(0), 'count')]),
        productConfigs
    );

    const productConfigFilter = r.allPass(
        r.filter(r.complement(r.isNil), [
            isSauceSelected ? r.complement(r.prop)('isDough') : null,
            r.propSatisfies(r.lt(0), 'count'),
        ])
    );

    const images = r.pipe(
        r.filter(productConfigFilter),
        r.sortBy((pc) => productConfigPositionById[pc.id]),
        r.map(r.prop('image')),
        r.filter(r.complement(r.isNil))
    )(productConfigs);

    const isDoughSelected = r.any(
        r.allPass([r.prop('isDough'), r.propSatisfies(r.lt(0), 'count')]),
        productConfigs
    );

    return r.filter(
        r.complement(r.isNil),
        r.concat(
            !isSauceSelected && !isDoughSelected
                ? [
                      r.path(
                          ['productConfigurator', 'assets', 'img', 'dough'],
                          state
                      ),
                  ]
                : [],
            images
        )
    );
}

export function images(state) {
    return stateToConfigImages(state);
}

export function allImages(state) {
    return r.pipe(
        r.pathOr({}, ['productConfigurator', 'productConfigs']),
        r.values,
        r.map(r.prop('image')),
        r.concat([
            r.path(['productConfigurator', 'assets', 'img', 'dough'], state),
        ]),
        r.filter(r.complement(r.isNil))
    )(state);
}
